var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export var BottomNavigation = function (_React$Component) {
  _inherits(BottomNavigation, _React$Component);

  function BottomNavigation() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BottomNavigation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BottomNavigation.__proto__ || Object.getPrototypeOf(BottomNavigation)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      scrolling: false
    }, _this.onScroll = function () {
      var scrollTop = Math.max(_this.contentNode.scrollTop, 0);
      var lastScrollTop = _this.lastScrollTop;
      _this.lastScrollTop = scrollTop;
      if (_this.scrollTimer) {
        clearTimeout(_this.scrollTimer);
      }
      // reached bottom?
      var _window = _this.props.window || window;
      if (_this.contentNode.scrollHeight - _window.innerHeight < scrollTop) {
        _this.setState({
          scrolling: false
        });
        return;
      }
      /* only hide menu on scroll down */
      if (lastScrollTop >= scrollTop) {
        _this.setState({
          scrolling: false
        });
        return;
      }
      if (!_this.state.scrolling) {
        _this.setState({
          scrolling: true
        });
      }
      _this.scrollTimer = setTimeout(function () {
        _this.setState({
          scrolling: false
        });
      }, _this.props.scrollDuration);
    }, _this.scrollTop = function () {
      if (!_this.contentNode) {
        return;
      }
      var scrollDuration = _this.props.scrollDuration;
      var cosParameter = _this.contentNode.scrollTop / 2;
      var scrollCount = 0;
      var _window = _this.props.window || window;
      var oldTimestamp = _window.performance.now();
      var step = function step(newTimestamp) {
        scrollCount += Math.PI / (scrollDuration / (newTimestamp - oldTimestamp));
        if (scrollCount >= Math.PI) {
          _this.contentNode.scrollTop = 0;
        }
        if (_this.contentNode.scrollTop === 0) {
          return;
        }
        _this.contentNode.scrollTop = Math.round(cosParameter + cosParameter * Math.cos(scrollCount));
        oldTimestamp = newTimestamp;
        _window.requestAnimationFrame(step);
      };
      _window.requestAnimationFrame(step);
    }, _this.resetScrollTop = function () {
      if (_this.contentNode) {
        _this.contentNode.scrollTop = 0;
      }
    }, _this.scrollTopOrResetTop = function (event) {
      var linkNode = event.currentTarget.firstElementChild;
      if (linkNode.classList.contains('active')) {
        _this.scrollTop();
      } else {
        _this.resetScrollTop();
      }
    }, _this.updateContentNode = function (content) {
      if (!content) {
        return;
      }
      var scrollTop = _this.contentNode ? _this.contentNode.scrollTop : 0;
      _this.contentNode = content;
      _this.contentNode.scrollTop = scrollTop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(BottomNavigation, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.lastScrollTop = 0;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.scrollTimer) {
        clearTimeout(this.scrollTimer);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          links = _props.links,
          inverted = _props.inverted;

      var menuClassName = classNames('mdc-BottomNavigation-menu', {
        'mdc-BottomNavigation-menu--inverted': inverted,
        'mdc-BottomNavigation-menu--narrow': links.length > 3
      });
      return React.createElement(
        'div',
        { onScroll: this.onScroll, className: classNames('mdc-BottomNavigation', { scrolling: this.state.scrolling }) },
        React.createElement(
          'div',
          { ref: this.updateContentNode, className: 'mdc-BottomNavigation-content' },
          children
        ),
        React.createElement(
          'div',
          { className: menuClassName },
          links.map(function (link, index) {
            return React.createElement(
              'div',
              { key: index, className: 'mdc-BottomNavigation-menu-item', onClick: _this2.scrollTopOrResetTop },
              link
            );
          })
        )
      );
    }
  }]);

  return BottomNavigation;
}(React.Component);

BottomNavigation.propTypes = {
  scrollDuration: PropTypes.number
};
BottomNavigation.defaultProps = {
  scrollDuration: 800
};
export var BottomNavigationText = function BottomNavigationText(_ref2) {
  var children = _ref2.children;
  return React.createElement(
    'div',
    { className: 'mdc-BottomNavigation-menu-item-text' },
    children
  );
};


//////////////////
// WEBPACK FOOTER
// ../es/js/bottomnavigation/index.js
// module id = 281
// module chunks = 0